export default "__VITE_ASSET__BBil4QRG__$_?react__"